import { toast } from '@insight-health-ai/roseate/components';
import { message as antdMessage } from 'antd';

const isMobile = window.innerWidth < 1260;

export const showToastError = (message) => {
  toast.dismiss();
  if (isMobile) {
    antdMessage.error(message);
  } else {
    toast.error(message, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
      progressStyle: { background: '#ff4d4f' },
      className: 'fixed top-0 w-80 mt-3 bg-white font-sans',
    });
  }
};
